<div class='SignupCreate__wrapper'>
  <div class='SignupCreate__wrapper__container'>
    <p class='mt-5 mb-0 font-weight-bolder'>
      Please select the type of user you want to register and complete the form
      below.
    </p>
    <div
      [formGroup]='registerForm'
      class='SignupCreate__wrapper__container__form'>
      <mat-radio-group
        aria-label='Select an user type'
        formControlName='user_type'>
        <div class='SignupCreate__wrapper__container__form__row'>
          <div
            (click)="selectType('user')"
            class='SignupCreate__wrapper__container__form__row__radio'>
            <mat-radio-button class='me-2' value='user'></mat-radio-button>
            <p
              class='SignupCreate__wrapper__container__form__row__radio__label'>
              Single User
            </p>
            <p class='SignupCreate__wrapper__container__form__row__radio__hint'>
              If you will be the one sending emails to you prospects.
            </p>
          </div>
          <div
            (click)="selectType('manager')"
            class='SignupCreate__wrapper__container__form__row__radio'>
            <mat-radio-button class='me-2' value='manager'></mat-radio-button>
            <p
              class='SignupCreate__wrapper__container__form__row__radio__label'>
              Manager
            </p>
            <p class='SignupCreate__wrapper__container__form__row__radio__hint'>
              If you will be managing at least on rep sending emails.
            </p>
          </div>
        </div>
      </mat-radio-group>
      <div class='SignupCreate__wrapper__container__form__row'>
        <div class='SignupCreate__wrapper__container__form__row__note'>
          <p>
            <span>Note:</span> The manager account does not send emails. It is
            for reporting and visibility and there is no cost associated with
            the manager account.
          </p>
        </div>
      </div>
      <div class='SignupCreate__wrapper__container__form__row mt-3'>
        <app-text-field
          class='w-100'
          formControlName='email'
          placeholder='Email Address'
          type='email'></app-text-field>
        <div
          *ngIf='hasControlErrors(email) || isEmailTaken'
          class='alert alert-danger'>
          <div *ngIf='email.errors && email.errors.required'>
            <p class='mb-0'>Email address is required.</p>
          </div>
          <div *ngIf='email.errors && email.errors.minlength'>
            <p class='mb-0'>
              Email address must be at least 4 characters long.
            </p>
          </div>
          <div *ngIf='email.errors && email.errors.email'>
            <p class='mb-0'>Please, enter valid email address</p>
          </div>
          <div *ngIf='isEmailTaken'>
            <p class='mb-0'>Email address is already taken</p>
          </div>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6'>
          <app-text-field
            formControlName='first_name'
            placeholder='First name'></app-text-field>
          <div *ngIf='hasControlErrors(first_name)' class='alert alert-danger'>
            <div *ngIf='first_name.errors.required'>
              <p class='mb-0'>First Name is required.</p>
            </div>
          </div>
        </div>
        <div class='col col-12 col-md-6 mt-3 mt-sm-0'>
          <app-text-field
            formControlName='last_name'
            placeholder='Last name'></app-text-field>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12'>
          <app-text-field
            class='w-100'
            formControlName='company'
            placeholder='Company'></app-text-field>
          <div *ngIf='hasControlErrors(company)' class='alert alert-danger'>
            <div *ngIf='company.errors.required'>
              <p class='mb-0'>Company is required.</p>
            </div>
          </div>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12'>
          <app-text-field
            class='w-100'
            formControlName='phone_number'
            placeholder='Phone number'></app-text-field>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6'>
          <app-text-field
            formControlName='address1'
            placeholder='Address 1'></app-text-field>
        </div>
        <div class='col col-12 col-md-6 mt-3 mt-sm-0'>
          <app-text-field
            formControlName='address2'
            placeholder='Address 2'></app-text-field>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6'>
          <app-select
            (selection)='onCountrySelect($event)'
            [items]='getCountryItems()'
            formControlName='country'
            label='Select country'></app-select>
          <div
            *ngIf='(country.dirty || country.touched) && country.errors'
            class='alert alert-danger'>
            <div *ngIf='country.errors.required'>
              <p class='mb-0'>Please, select country.</p>
            </div>
          </div>
        </div>
        <div class='col col-12 col-md-6 mt-3 mt-sm-0'>
          <app-text-field
            formControlName='city'
            placeholder='City'></app-text-field>
          <div *ngIf='hasControlErrors(city)' class='alert alert-danger'>
            <div *ngIf='city.errors.required'>
              <p class='mb-0'>City is required.</p>
            </div>
          </div>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6'>
          <app-select
            *ngIf="!selectedCountry || selectedCountry === 'US'"
            [items]="getStates('US')"
            formControlName='state'
            label='State'></app-select>
          <app-select
            *ngIf="selectedCountry && selectedCountry === 'CA'"
            [items]="getStates('CA')"
            formControlName='state'
            label='State'></app-select>
          <div
            *ngIf='(state.dirty || state.touched) && state.errors'
            class='alert alert-danger'>
            <div *ngIf='state.errors.required'>
              <p class='mb-0'>Please, select a state.</p>
            </div>
          </div>
        </div>
        <div class='col col-12 col-md-6 mt-3 mt-sm-0'>
          <app-text-field
            formControlName='zip'
            placeholder='Zip Code...'></app-text-field>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12'>
          <app-select
            *ngIf="!selectedCountry || selectedCountry === 'US'"
            [items]="getTimezones('US')"
            formControlName='time_zone'
            label='Selected Time Zone'></app-select>
          <app-select
            *ngIf="selectedCountry && selectedCountry === 'CA'"
            [items]="getTimezones('CA')"
            formControlName='time_zone'
            label='Selected Time Zone'></app-select>
          <div
            *ngIf='(time_zone.dirty || time_zone.touched) && time_zone.errors'
            class='alert alert-danger'>
            <div *ngIf='time_zone.errors.required'>
              <p class='mb-0'>Please, select a timezone.</p>
            </div>
          </div>
          <p class='mt-2'>
            Please be sure to click Observe DST for Eastern Time and other zones
            if applicable.
          </p>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12'>
          <mat-checkbox formControlName='user_dst_bit'
          >Select to Observe DST
          </mat-checkbox
          >
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12'>
          <app-text-field
            formControlName='password'
            placeholder='Password'
            type='password'></app-text-field>
          <div *ngIf='hasControlErrors(password)' class='alert alert-danger'>
            <div *ngIf='password.errors.required'>
              <p class='mb-0'>Password is required.</p>
            </div>
            <div *ngIf='password.errors.minlength'>
              <p class='mb-0'>Password must be at least 8 characters long.</p>
            </div>
            <div *ngIf='password.errors.pattern'>
              <ul>
                <li>Numbers: 0 to 9</li>
                <li>Uppercase Letters: ABC</li>
                <li>Lowercase Letters: abc</li>
                <li>Special Characters: ! @ # $ % & * ( ) _ + - = &#123;} [ ] ; : ' " < > , . ? /</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12'>
          <app-text-field
            formControlName='confirm_password'
            placeholder='Confirm Password...'
            type='password'></app-text-field>
          <div
            *ngIf='hasControlErrors(confirm_password)'
            class='alert alert-danger'>
            <div *ngIf='confirm_password.errors.required'>
              <p class='mb-0'>Please, repeat your password</p>
            </div>
            <div *ngIf='confirm_password.errors.minlength'>
              <p class='mb-0'>Password must be at least 8 characters long.</p>
            </div>
            <div *ngIf='confirm_password.errors.not_same_as'>
              <p class='mb-0'>Password didn't math as above</p>
            </div>
          </div>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 text-center'>
          <app-button
            (click)='submitForm()'
            [style]="'rounded'"
            color='orange'
            size='normal'
            text='Next'></app-button>
        </div>
      </div>
      <div class='row mt-5'>
        <div
          class='col flex-grow-1 w-lg-50 m-auto text-center RegisterStepCreate_wrapper_footer'>
          <p class='p-0 mb-0'>
            By clicking "NEXT", I agree to the <a href='#'>Privacy</a> ,<a
            href='/terms'
          >Terms</a
          >
            of Use and <a href='#'>AUP</a>
          </p>
          <p>
            (I may receive communications from Retreva® and can change my
            notification preferences in
            <a href='/accounts/sign_in'>My Account</a> )
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
